module.exports = __webpack_public_path__ + "img/signi_logo.e8b38abc.png";